import * as React from 'react';
export const pieChartSvg = React.forwardRef(function pieChartSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.044.002a.974.974 0 0 0-.715.254.986.986 0 0 0-.329.73v5.019c0 .548.44.995.994.995h5.012A.992.992 0 0 0 16 6.005v-.021l-.001-.02A6.32 6.32 0 0 0 10.044.001Zm.456 1.559v3.94h3.94a4.82 4.82 0 0 0-3.94-3.94Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.079 3.25c.6 0 .988.505.988 1.019v4.62h4.685c.554 0 .998.447.998 1v.033c-.159 3.51-3.176 6.28-6.764 6.067-3.185-.182-5.757-2.774-5.97-5.94C-.233 6.44 2.54 3.43 6.04 3.25h.039Zm-.512 1.56a4.867 4.867 0 0 0-4.055 5.138c.164 2.423 2.142 4.407 4.56 4.544h.002a4.89 4.89 0 0 0 5.123-4.101H6.814a1.249 1.249 0 0 1-1.247-1.247V4.809Z',
    }),
  );
});
pieChartSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pieChart = {
  category: 'icon',
  colorable: true,
  name: 'pieChart',
  svg: pieChartSvg,
};
